var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserDetails"},[_c('h3',{staticClass:"mb-3 text-right"},[_vm._v("Detalles de la colocación publica")]),_c('b-card',[_c('b-container',{attrs:{"fluid":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }